import {IObjectOptions} from 'fabric/fabric-impl';

export const DEFAULT_OBJ_CONFIG: IObjectOptions = {
  lockScalingFlip: true,
  originY: 'center',
  originX: 'center',
  lockMovementX: true,
  lockMovementY: true,
  borderColor: 'transparent',
};
